import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ── Auth ──────────────────────────────────────────────────────────────────────
export const loginAdmin = (data) => api.post('/auth/login', data).then((r) => r.data);
export const verifyAdminToken = () => api.get('/auth/verify').then((r) => r.data);

// ── Sermons ──────────────────────────────────────────────────────────────────
export const getSermons = () => api.get('/sermons/').then((r) => r.data);
export const getRecentSermons = () => api.get('/sermons/recent').then((r) => r.data);
export const getSermon = (id) => api.get(`/sermons/${id}`).then((r) => r.data);
export const createSermon = (data) => api.post('/sermons/', data).then((r) => r.data);
export const updateSermon = (id, data) => api.put(`/sermons/${id}`, data).then((r) => r.data);
export const deleteSermon = (id) => api.delete(`/sermons/${id}`).then((r) => r.data);

// ── Events ───────────────────────────────────────────────────────────────────
export const getEvents = () => api.get('/events/').then((r) => r.data);
export const getUpcomingEvents = () => api.get('/events/upcoming').then((r) => r.data);
export const getEvent = (id) => api.get(`/events/${id}`).then((r) => r.data);
export const createEvent = (data) => api.post('/events/', data).then((r) => r.data);
export const updateEvent = (id, data) => api.put(`/events/${id}`, data).then((r) => r.data);
export const deleteEvent = (id) => api.delete(`/events/${id}`).then((r) => r.data);

// ── Ministries ───────────────────────────────────────────────────────────────
export const getMinistries = () => api.get('/ministries/').then((r) => r.data);
export const getMinistry = (id) => api.get(`/ministries/${id}`).then((r) => r.data);
export const createMinistry = (data) => api.post('/ministries/', data).then((r) => r.data);
export const updateMinistry = (id, data) => api.put(`/ministries/${id}`, data).then((r) => r.data);
export const deleteMinistry = (id) => api.delete(`/ministries/${id}`).then((r) => r.data);

// ── Announcements ─────────────────────────────────────────────────────────────
export const getAnnouncements = () => api.get('/announcements/').then((r) => r.data);
export const createAnnouncement = (data) => api.post('/announcements/', data).then((r) => r.data);
export const updateAnnouncement = (id, data) => api.put(`/announcements/${id}`, data).then((r) => r.data);
export const deleteAnnouncement = (id) => api.delete(`/announcements/${id}`).then((r) => r.data);

// ── Contact ───────────────────────────────────────────────────────────────────
export const sendContactMessage = (data) => api.post('/contact/', data).then((r) => r.data);

// ── Prayer ────────────────────────────────────────────────────────────────────
export const submitPrayerRequest = (data) => api.post('/prayer/', data).then((r) => r.data);

// ── Gallery ───────────────────────────────────────────────────────────────────
export const getGallery = () => api.get('/gallery/').then((r) => r.data);
export const createGalleryImage = (data) => api.post('/gallery/', data).then((r) => r.data);
export const updateGalleryImage = (id, data) => api.put(`/gallery/${id}`, data).then((r) => r.data);
export const deleteGalleryImage = (id) => api.delete(`/gallery/${id}`).then((r) => r.data);

// ── Live ──────────────────────────────────────────────────────────────────────
export const getLiveStatus = () => api.get('/live/').then((r) => r.data);
export const setLiveStatus = (data) => api.post('/live/', data).then((r) => r.data);

// ── Leadership ────────────────────────────────────────────────────────────────
export const getLeadership = () => api.get('/leadership/').then((r) => r.data);
export const createLeader = (data) => api.post('/leadership/', data).then((r) => r.data);
export const updateLeader = (id, data) => api.put(`/leadership/${id}`, data).then((r) => r.data);
export const deleteLeader = (id) => api.delete(`/leadership/${id}`).then((r) => r.data);
